import { useRef, useEffect } from 'react';

const useOutsideClick = (callback) => {
  const innerRef = useRef();
  const callbackRef = useRef();

  const handleClick = (e) => {
    // The path is fixed when the click is dispatched, so it still holds an element that the click itself
    // replaced (a calendar year tile swapping to the month view); `contains(e.target)` would call that outside.
    const path = e.composedPath ? e.composedPath() : [];
    const isInside = innerRef.current
      && (path.includes(innerRef.current) || innerRef.current.contains(e.target));

    if (innerRef.current && callbackRef.current && !isInside) {
      callbackRef.current(e);
    }
  };

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, []);

  return innerRef;
};

export default useOutsideClick;
